import React, { useMemo, useState } from 'react';
import Table from '../../components/Table';
import Empty from '../../components/Empty';
import { useSelector } from 'react-redux';
import Skeleton from 'src/components/Skeleton/Skeleton';
import EditPdfName from './EditPdfName';
import { useServiceRequestPDFs } from 'src/pages/Request/CustomHooks/UseServiceRequestPDFs';
import { createPDFRequestTableColumns } from 'src/pages/Request/helpers';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import './request.scss';

const SKELETON_ROW_COUNT: number = 12;

const Request = () => {
  const [showOverlay, setShowOverLay] = useState(false);
  const [pdfdata, setpdfdata] = useState(null);

  const auth = useSelector((state: any) => state.auth);
  const userID = auth && auth.user && auth.user.id;

  const {
    serviceRequestPDFDownloadList,
    loading: csvExportLoading,
    error: serviceRequestPDFError,
    deletePDF,
    exportPDF,
    editFormData,
    initializeEditForm,
    updatePdfName,
    validateAndSubmitEdit,
  } = useServiceRequestPDFs(userID);

  const editPdfname = (e: any, pdfDataItem: any) => {
    setpdfdata(pdfDataItem);
    initializeEditForm(pdfDataItem);
    setShowOverLay(true);
  };

  const handlepopup = (value: boolean) => {
    setShowOverLay(value);
  };

  const onDeletePDFfile = async (unitId: any) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    await deletePDF(unitId, user.id);
  };

  const tableColumns = useMemo(
    () => createPDFRequestTableColumns(exportPDF, editPdfname, onDeletePDFfile),
    [exportPDF, editPdfname, onDeletePDFfile]
  );

  const skeletonColumns: any[] = useMemo(
    () =>
      tableColumns.map((c: any) => ({
        ...c,
        cell: () => <Skeleton variant="text" width="70%" />,
      })),
    [tableColumns]
  );

  const skeletonData: any[] = useMemo(
    () =>
      Array.from({ length: SKELETON_ROW_COUNT }, (_: unknown, i: number) => ({
        id: `pdf-request-skeleton-${i}`,
      })),
    []
  );

  if (serviceRequestPDFError) {
    return (
      <WithNavigation
        title="Request"
        hide={true}
        border
        top={
          <div style={{ padding: '50px' }}>
            <p>Error: {serviceRequestPDFError}</p>
          </div>
        }
      />
    );
  }

  return (
    <WithNavigation
      title="Request"
      hide={true}
      border
      top={
        <div style={{ padding: '50px' }}>
          {csvExportLoading ? (
            <>
              <h1 className="headingMobile">Download PDF Requests</h1>
              <Table columns={skeletonColumns} data={skeletonData} />
            </>
          ) : serviceRequestPDFDownloadList.length > 0 ? (
            <>
              <h1 className="headingMobile">Download PDF Requests</h1>
              <Table
                columns={tableColumns}
                data={serviceRequestPDFDownloadList}
              />
            </>
          ) : (
            <Empty
              direction="ttb"
              headline="No Request yet"
              strapline="All download request which you have requested will be listed here so it's easier for you to download it later."
              image={
                <img
                  alt="No Announcements yet"
                  src="/assets/empty/properties.svg"
                />
              }
            />
          )}
          {showOverlay && pdfdata && (
            <EditPdfName
              handlepopup={handlepopup}
              editFormData={editFormData}
              updatePdfName={updatePdfName}
              validateAndSubmitEdit={validateAndSubmitEdit}
            />
          )}
        </div>
      }
    />
  );
};

export default Request;
